export default __webpack_public_path__ + "static/media/Katie 9781408335598.240c5655.jpg";